<div class="relative flex max-h-[95dvh] flex-1 flex-col p-6">
  <div class="flex items-start justify-between">
    <h2 class="text-xl font-bold md:pl-4 md:pt-4">{{ 'profile.subscription.modal.headline' | transloco }}</h2>
  </div>

  <div class="mb-6 mt-2 flex w-full flex-1 overflow-auto px-4 max-md:w-full md:px-8 lg:mt-4">
    <app-product-list class="mx-auto block h-fit overflow-visible pb-4 pt-8 max-md:flex-1 xl:pt-0" />
  </div>
</div>
